import React from 'react';
import { FormattedMessage } from 'react-intl';
import { borrowingQuotaShape } from '@bibliocommons/bc-prop-types';

import './BorrowingQuota.scss';

export default function BorrowingQuota({ quota }) {
  return (
    <div className="cp-borrowing-quota">
      <div className="name">
        <FormattedMessage id={`digital_service_type_${quota.get('type', '').toLowerCase()}`} />
      </div>

      <div className="remaining">
        <FormattedMessage
          id="borrowing_quota_count"
          values={{
            remaining: quota.get('total', 0) - quota.get('remaining', 0),
            total: quota.get('total', 0)
          }} />
      </div>
    </div>
  );
}

BorrowingQuota.propTypes = {
  quota: borrowingQuotaShape
};



// WEBPACK FOOTER //
// ./app/components/borrowing/shared/BorrowingQuota/BorrowingQuota.jsx